import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import parse from 'html-react-parser';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { AppTheme } from '../styles/AppTheme';
import { CommonStyles } from '../styles/Styles';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { HelmetComponent } from '../common/components/HelmetComponent';
import { RenderHtmlTextHelper } from '../helpers/RenderHtmlTextHelper';
import { AppHelper } from '../helpers/AppHelper';
import { productImageSliderSettings } from '../components/ProductSliderSettings'
import { relativesettings } from '../components/SliderSettings'
import { AppConfig } from '../AppConfig';
import { VideoDialog } from '../components/VideoDialog';
import { ContactComponent } from '../components/ContactComponent';
import { EmptyMsgView } from '../components/EmptyMsgView';
import { CommonTheme } from '../styles/Styles';
import NumberFormat from 'react-number-format';
import { PageAnalytics } from '../common/helpers/PageAnalytics';
import { BreadCrumbs } from '../common/components/BreadCrumbs';
import { ReasonsComponent } from '../components/ReasonsComponent';

export class ProductDetails extends Component {
  constructor(props) {
    super(props)
    this.slug = this.props.match.params.slug ? this.props.match.params.slug : null
    this.tabIndexes = {
      features: 0,
      technicalSpecs: 1,
      downloadables: 2,
      about: 3
    }
    this.paramsIdToName = {}
    this.state = {
      videoDialog: false,
      groupDeal: false,
      currentDownloadable: false,
      fetchState: ApiHelper.State.LOADING,
      value: 0,
      modalVisible: false,
      productDescr: [
        {
          id: '1',
          title: 'Features'
        },
        {
          id: '2',
          title: 'Specs'
        },
        {
          id: '3',
          title: 'Downloads'
        },
        {
          id: '4',
          title: 'Vendor'
        },
      ],
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.fetchItems(this.slug)
    PageAnalytics.gaTrkCustomDimension('dimension1', this.slug)
  }

  fetchItems(id) {
    this.setState({ fetchState: ApiHelper.State.LOADING })

    const options = {
      method: 'GET',
      authWithKey: true,
      endPoint: ApiHelper.makeUrlPath(['miscs', 'products'], { slug: id })
    };

    ApiHelper.call(options, (err, results) => {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }

      const productImages = this.getProductImages(results)
      this.paramsIdToName = this.getParamsIdToNameMap(results);

      if (results.prodVideo) {
        productImages.push({
          image: require('../assets/images/play.png'),
          type: 'prodVideo'
        })
      }

      this.breadCrumbs = [
        { title: 'Home', to: '/' },
        { title: 'Product' },
      ]

      this.metaData = {
        title: results.metaTitle,
        descr: results.metaDescr,
        searchable: results.metaKeywords
      }

      this.setState({
        productDetails: results,
        docs: results.docs ? AppHelper.dictToArray(results.docs) : [],
        productImage: productImages.length > 0 && productImages[0].image,
        brand: results && results.__resolves && results.__resolves.brand, //TODO:  brand is taken from the first entry of list of brands
        productImages: productImages,
        groupDeal: this.isProductInGrpDeal(results),
        fetchState: ApiHelper.State.READY
      })
    });
  }

  isProductInGrpDeal = (item) => {
    if (item &&
      item.__resolves &&
      item.__resolves.memberLists) {
      const mLists = item.__resolves.memberLists
      for (const l of mLists) {
        if (l.itype === 'GRP_DEAL') {
          return true
        }
      }
    }
    return false
  }

  getParamsIdToNameMap = (results) => {
    if (!results || !results.__resolves || !results.__resolves.cats) {
      return {}
    }

    const paramIdToName = {}

    for (const cat of results.__resolves.cats) {
      if (!cat.params) {
        continue
      }

      let paramIdToNameArr = []
      for (const key in cat.params) {
        paramIdToNameArr.push({
          key: key,
          title: cat.params[key].title,
          order: cat.params[key].order
        })
      }

      paramIdToNameArr = AppHelper.sortParamsByOrder(paramIdToNameArr)

      for (const item of paramIdToNameArr) {
        paramIdToName['key_' + item.key] = item.title
      }
    }
    return paramIdToName
  }

  getProductImages = (results) => {
    let productImages = []
    if (results && results.images && Object.keys(results.images).length !== 0) {
      productImages = Object.keys(results.images).sort(function (a, b) {
        return results.images[a].order.localeCompare(results.images[b].order);
      }).map(function (k) {
        return results.images[k];
      });
    }
    return productImages
  }

  getProductSlider() {
    return (
      <div className={css(Styles.imageList)}>
        {this.getSlider(productImageSliderSettings, Styles.sliderContainer)}
      </div>
    )
  }

  getSlider(settings, style) {
    return (
      <Slider
        {...settings}
        className={css(style)}>
        {this.state.productImages.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => this.setProductimage(item)}
              className={css(Styles.imageContainer)} >
              <img
                src={item.image}
                className={css(Styles.image)} />
            </div>
          )
        })
        }
      </Slider >
    )
  }

  handleModal = () => {
    this.setState({
      modalVisible: !this.state.modalVisible,
      currentDownloadable: null,
    })
  }

  showContactModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  getPriceContainer = () => {
    if (this.state.productDetails &&
      this.state.productDetails.price &&
      this.state.productDetails.priceDiscounted) {
      return (
        <div className={css(Styles.priceRangeContainer)}>
          {AppHelper.renderCurrencyFormat(AppHelper.convertPaiseToRs(this.state.productDetails.price), 'STRIKE')}
          {AppHelper.renderCurrencyFormat((AppHelper.convertPaiseToRsAfterDiscount(this.state.productDetails.price, this.state.productDetails.priceDiscounted)))}
        </div>
      )
    } else if (this.state.productDetails &&
      this.state.productDetails.price) {
      return (
        <div>
          {AppHelper.renderCurrencyFormat(AppHelper.convertPaiseToRs(this.state.productDetails.price))}
        </div>
      )
    } else if (this.state.productDetails &&
      this.state.productDetails.priceBandHigh &&
      this.state.productDetails.priceBandLow) {
      return (
        <div className={css(Styles.priceRangeContainer)}>
          {AppHelper.renderCurrencyFormat(AppHelper.convertPaiseToRs(this.state.productDetails.priceBandLow))}
          <p className={css(Styles.priceDivder)}>to</p>
          {AppHelper.renderCurrencyFormat(AppHelper.convertPaiseToRs(this.state.productDetails.priceBandHigh))}
        </div>
      )
    }
  }

  getProductDetails() {
    return (
      <div className={css(Styles.productDetailsContainer)} >
        <div className={css(Styles.productSlider)}>
          {this.getSlider(relativesettings, Styles.productSlider)}
        </div>
        <div className={css(Styles.productDetailsMainContainer)}>
          {this.state.productImages.length > 0 &&
            <div
              className={css(Styles.productImageContainer)} >
              <img src={this.state.productImage} className={css(Styles.productImage)} />
            </div>
          }

          {!this.state.productImages.length &&
            <div
              className={css(Styles.productImageContainer)} >
              <p>Image is not available</p>
            </div>
          }

          <div className={css(Styles.productDetailsSubContainer)}>
            {this.state.productDetails &&
              <h1 className={css(Styles.produtTitle)}>
                {this.state.productDetails.title}
              </h1>
            }

            <Link
              to={'/brands/' + this.state.brand.slug}
              className={css(CommonStyles.link)}>
              <p className={css(Styles.sellerText)}>
                By
                <span className={css(Styles.sellerName)}>
                  {this.state.brand.title}
                </span>
              </p>
            </Link>

            {this.getPriceContainer()}

            <div className={css(Styles.mobButtonContainer)}>
              <div className={css(Styles.requestButtonContainer)}>
                {this.getRequestButton()}
                {this.getWhatsapBtn()}
              </div>
              {this.getCompareButton()}
            </div>

            <div className='descr'>
              {this.state.productDetails.descr &&
                parse(RenderHtmlTextHelper.renderHtmlText(this.state.productDetails.descr))
              }
            </div>
          </div>
        </div>

        <div className={css(Styles.buttonContainer)}>
          {this.getCompareButton()}
          {this.getRequestButton()}
          {this.getWhatsapBtn()}
        </div>
      </div >
    )
  }

  getCompareButton() {
    if (!this.state.productDetails ||
      !this.state.productDetails.__resolves ||
      !this.state.productDetails.__resolves.cats ||
      this.state.productDetails.__resolves.cats.length === 0) {
      return
    }

    this.catSlug = this.state.productDetails.__resolves.cats[0].slug
    return (
      <Link
        to={{
          pathname: '/compare/' + this.catSlug,
          state: {
            item: this.state.productDetails
          }
        }}
        className={css(Styles.compareButtonContainer)}
      >
        <Button variant='contained' className={css(Styles.compareButton)}>
          COMPARE SIMILAR PRODUCTS
        </Button>
      </Link>
    )
  }

  getRequestButton() {
    return (
      <div className={css(Styles.webRequestButton)}>
        <Button onClick={this.showContactModal} variant='contained' className={css(Styles.requestButton)}>
          {this.state.groupDeal ? 'JOIN DEAL' : 'REQUEST FOR QUOTE'}
        </Button>
      </div>
    )
  }

  sendAnalytics = (action) => {
    PageAnalytics.gaTrkEvent(
      'general',
      action,
      'PRODUCT_PAGE',
      null)
  }

  getWhatsapBtn() {
    const url = 'I am interested in the product \n' + window.location.href
    return (
      <Link
        onClick={() => this.sendAnalytics('whatsapp')}
        to={AppConfig.WHATSAPP_PHONE + encodeURI(url)}
        target='_blank'
        className={css(CommonStyles.link)}
      >
        <img
          src={require('../assets/images/whatsapp.svg')}
          className={css(Styles.whtsAppImage)} />
      </Link>
    )
  }

  getProductTabs() {
    return (
      <div className={css(Styles.productDescriprionContainer)} className='productDetails'>
        <Tabs
          variant={window.innerWidth < 768 ? 'scrollable' : 'standard'}
          TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
          value={this.state.value}
          onChange={this.handleChange}
          classes={{
            root: css(Styles.customTabStyle)
          }}
        >
          {this.state.productDescr.map((item, index) => {
            return (
              <Tab
                key={index}
                className={css(Styles.tab)}
                classes={{
                  selected: css(Styles.selectedTab),
                }}
                label={item.title}
              />
            )
          })}
        </Tabs>
        {this.getFeatures()}
        {this.getTechnicalSpecs()}
        {this.getDownloadables()}
        {this.getVendorDetails()}
      </div>
    )
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  getFeatures() {
    const index = this.tabIndexes.features
    return (
      <div hidden={this.state.value !== index} value={this.state.value} index={index}>
        {this.state.productDetails && this.state.productDetails.features &&
          parse(RenderHtmlTextHelper.renderHtmlText(this.state.productDetails.features))
        }
      </div>
    )
  }

  getTechnicalSpecs() {
    const index = this.tabIndexes.technicalSpecs
    return (
      <div hidden={this.state.value !== index} value={this.state.value} index={index}>
        {
          this.state.productDetails && this.state.productDetails.params && this.paramsIdToName &&
          Object.keys(this.paramsIdToName).length > 0 &&
          Object.keys(this.paramsIdToName).map((key, index) => {
            if (!this.paramsIdToName[key] || !this.state.productDetails.params[key]) {
              return
            }
            return (
              <div key={index} className={css(Styles.technicalSpecsContainer)}>
                <p className={css(Styles.technicalSpecsTitle)}>{this.paramsIdToName[key]}</p>
                {this.state.productDetails.params &&
                  <p className={css(Styles.technicalSpecsValue)}>{this.state.productDetails.params[key]}</p>
                }
              </div>
            )
          })
        }
      </div>
    )
  }

  onDownloadableClick = (item) => {
    this.setState({
      currentDownloadable: item.doc,
    }, () => this.setState({ modalVisible: true }))
  }

  getDownloadables() {
    const index = this.tabIndexes.downloadables
    return (
      <div hidden={this.state.value !== index} value={this.state.value} index={index}>
        <div className={css(Styles.downloadablesMainContainer)}>
          {this.state.docs.length > 0 &&
            this.state.docs.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={() => this.onDownloadableClick(item)}
                  className={css(Styles.downloadableLink)}>
                  <div className={css(Styles.downloadablesContainer)}>
                    <div className={css(Styles.downloadablesSubContainer)}>
                      <img
                        className={css(Styles.docImage)}
                        src={AppHelper.setDocImage(item)} />
                    </div>
                    <p className={css(Styles.downloadableTitle)}>{item.title}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  getVendorDetails() {
    const index = this.tabIndexes.about
    return (
      <div hidden={this.state.value !== index} value={this.state.value} index={index}>
        {this.state.productDetails && this.state.productDetails.aboutVendor &&
          parse(RenderHtmlTextHelper.renderHtmlText(this.state.productDetails.aboutVendor))
        }
      </div>
    )
  }

  setProductimage(item) {
    if (item.type === 'prodVideo') {
      this.setState({
        videoDialog: true
      })
    } else {
      this.setState({ productImage: item.image })
    }

  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return <EmptyMsgView msg={this.state.errMsg} />
    } else {
      return this.readyView();
    }
  }

  handleVideoDialog = () => {
    this.setState({
      videoDialog: !this.state.videoDialog,
    })
  }

  readyView() {
    return (
      <div className={css(CommonStyles.container, Styles.container)}>

        <div className={css(Styles.bcContainer)}>
          <BreadCrumbs breadCrumbs={this.breadCrumbs} />
        </div>

        <div className={css(Styles.innerContainer)}>

          <HelmetComponent page={'product'} metaData={this.metaData} />

          <div className={css(Styles.leftContainer)}>
            {this.getProductSlider()}
          </div>
          <div className={css(Styles.rightContainer)}>
            {this.getProductDetails()}
            {this.getProductTabs()}

            <div className={css(Styles.reasonContainer)}>
              <ReasonsComponent />
            </div>

            {this.state.modalVisible &&
              <ContactComponent
                modalVisible={this.state.modalVisible}
                handleModal={this.handleModal}
                currentDownloadable={this.state.currentDownloadable}
                groupDeal={this.state.groupDeal}
                productDetails={this.state.productDetails}
              />
            }

            {this.state.productDetails && this.state.productDetails.prodVideo &&
              <VideoDialog
                modalVisible={this.state.videoDialog}
                handleModal={this.handleVideoDialog}
                videoLink={this.state.productDetails.prodVideo} />
            }
          </div>
        </div>
      </div>
    )
  }
}

const upperSectionDimension = 300
const Styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    //alignItems: 'center'
  },
  innerContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    },
  },
  leftContainer: {
    width: 70,
    marginRight: 20,
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      width: '100%',
      alignItems: 'center'
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      //width: '20%',
    },
  },
  rightContainer: {
    marginTop: 0,
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    //marginTop: '30px',
    '@media (max-width: 767px)': {
      width: CommonTheme.mobViewPort,
      alignSelf: 'center',
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      width: '80%',
    },
  },
  reasonContainer: {
    marginTop: 10
  },
  productDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  productDetailsMainContainer: {
    display: 'flex',
    '@media(max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  productImageContainer: {
    display: 'flex',
    border: '1px solid lightgrey',
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: CommonTheme.white,
    height: upperSectionDimension, //TODO
    width: upperSectionDimension,
    '@media(min-width: 768px) and (max-width: 1024px)': {
      height: upperSectionDimension - 70,
      width: upperSectionDimension - 70
    },
    '@media(max-width: 767px)': {
      display: 'none'
    },
  },
  productDetailsSubContainer: {
    height: upperSectionDimension,
    flexDirection: 'column',
    display: 'flex',
    flex: 1,
    marginLeft: 15,
    '@media(min-width: 768px) and (max-width: 1024px)': {
      height: upperSectionDimension - 70,
    },
    '@media(max-width: 767px)': {
      marginLeft: 0,
      marginTop: 15,
      height: 'auto',
    }
  },
  produtTitle: {
    margin: '5px 0px',
    fontSize: '1.5em',
    '@media(max-width: 1024px)': {
      fontSize: '20px'
    },
  },
  sellerText: {
    margin: '5px 0px',
    color: 'black'
  },
  sellerName: {
    color: CommonTheme.color2,
    marginLeft: AppTheme.pagePadding,
    ':hover': {
      cursor: 'pointer' //TODO: disabled for now
    }
  },
  requestButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 0px',
    '@media(max-width: 767px)': {
      marginBottom: 15
    },
  },
  webRequestButton: {
    display: 'flex',
    minWidth: '230px',
    '@media(max-width: 767px)': {
      width: '100%'
    }
  },
  requestButton: {
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: CommonTheme.textColor, //TODO can we apply like this?
    color: CommonTheme.white,
    fontWeight: 'bolder',
    width: '100%',
    '@media(max-width: 767px)': {
      marginLeft: 0,
      width: '100%',
    },
    '@media(max-width: 1024px)': {
      fontSize: '12px'
    },
  },
  compareButton: {
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: CommonTheme.white,
    color: CommonTheme.textColor,
    fontWeight: 'bolder',
    width: '100%',
    '@media(max-width: 1024px)': {
      fontSize: '12px'
    },
  },
  whtsAppImage: {
    display: 'flex',
    width: '35px',
    height: '35px',
    marginLeft: AppTheme.pagePadding * 4
  },
  productDescriprionContainer: {
    marginTop: 'inherit'
  },
  tab: {
    minWidth: '15%',
    textTransform: 'none',
    color: CommonTheme.black,
    ':hover': {
      color: CommonTheme.color2
    },
    '@media(max-width: 767px)': {
      flex: 'none',
      fontSize: 12,
      width: '25%'
    },
    '@media(max-width: 340px)': {
      flex: 'none',
      fontSize: 11,
    }
  },
  selectedTab: {
    borderBottom: '3px solid #99b9c8',
    color: CommonTheme.color2,
    fontWeight: 'bold'
  },
  link: {
    textDecoration: 'none',
    color: 'black',
    flex: 0.3,
    margin: '0px 10px',
    minWidth: '30%',
    '@media(max-width: 767px)': {
      minWidth: '80%',
      flex: 0.8,
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      margin: '0px 5px',
    },
  },
  compareButtonContainer: {
    minWidth: '230px',
    textDecoration: 'none',
    marginRight: AppTheme.pagePadding * 4,
    '@media(max-width: 767px)': {
      width: '100%',
      marginRight: 0
    }
  },
  imageList: {
    display: 'flex',
    flex: 1,
    //marginTop: '30px',
    alignItems: 'flex-start',
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      display: 'none '
    },
  },
  sliderContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  imageContainer: {
    cursor: 'pointer',
    border: '1px solid lightgrey',
    //width: '100%',
    //height: '70px',
    //width: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    overflow: 'hidden',
    ///marginRight: '-3px',
    marginBottom: AppTheme.pagePadding * 2,
    '@media(max-width: 767px)': {
      height: '180px',
      width: '180px'
    },
    ':focus': {
      outline: 'none',
      border: '2px solid #84bf41'
    }
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  technicalSpecsContainer: {
    borderBottom: '1px solid lightgrey',
    display: 'flex',
    flexDirection: 'row'
  },
  technicalSpecsTitle: {
    flex: 0.5,
    color: CommonTheme.textColor,
    fontSize: CommonTheme.productDetailsFontSize,
    fontWeight: 'bolder',
    alignSelf: 'center',
    marginRight: 10,
  },
  technicalSpecsValue: {
    fontSize: CommonTheme.productDetailsFontSize,
    flex: 0.5
  },
  downloadablesMainContainer: {
    margin: '16px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    '@media(max-width: 767px)': {
      justifyContent: 'center',
    },
  },
  downloadablesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      cursor: 'pointer'
    }
  },
  downloadablesSubContainer: {
    backgroundColor: '#f4f4f4',
    padding: AppTheme.pagePadding * 7,
    border: '1px solid #A9C2CD',
    borderRadius: 5
  },
  docImage: {
    height: 40,
    width: 40,
    objectFit: 'contain'
  },
  downloadableLink: {
    textDecoration: 'none',
    marginLeft: 7,
    marginRight: 7
  },
  buttonContainer: {
    display: 'flex',
    marginTop: '30px',
    '@media(max-width: 767px)': {
      display: 'none '
    },
  },
  mobButtonContainer: {
    flexDirection: 'column',
    display: 'none',
    marginTop: '30px',
    '@media(max-width: 767px)': {
      display: 'flex ',
      marginTop: 15,
    },
  },
  productSlider: {
    display: 'none',
    '@media(max-width: 767px)': {
      display: 'flex ',
      width: '100%',
    },
  },
  productImage: {
    //maxWidth: '95%',
    //maxHeight: '95%',
    borderRadius: 15,
    maxWidth: '100%',
    maxHeight: '100%'
  },
  downloadableTitle: {
    color: '#737575',
    fontSize: CommonTheme.productDetailsFontSize,
  },
  customTabStyle: {
    borderBottom: '1px solid lightgrey',
  },
  priceDivder: {
    fontSize: CommonTheme.productDetailsFontSize - 1,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    marginRight: 10
  },
  priceRangeContainer: {
    display: 'flex',
  },
  bcContainer: {
    marginTop: 30,
    marginBottom: 20,
    '@media(max-width: 767px)': {
      marginLeft: '5% ',
      marginRight: '5%',
      marginTop: 0,
    },
  }
})


// WEBPACK FOOTER //
// ./src/screens/ProductDetails.js